/**
 * Retrieves a cookie value by name from document.cookie
 * @param name - The name of the cookie to retrieve
 * @returns The cookie value or null if not found
 */
export function getCookie(name: string): string | null {
  const cookieString = document.cookie;
  if (!cookieString) return null;

  const cookies = cookieString.split(';');
  
  for (let cookie of cookies) {
    cookie = cookie.trim();

    if (cookie.startsWith(name + '=')) {
      return decodeURIComponent(cookie.substring(name.length + 1));
    }
  }

  return null;
}

/**
 * Sets a cookie with the given name, value, and options
 * @param name - Cookie name
 * @param value - Cookie value
 * @param days - Number of days until expiration (optional)
 * @param path - Cookie path (default: '/')
 */
export function setCookie(
  name: string,
  value: string,
  days?: number,
  path: string = '/'
): void {
  let expires = '';
  
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = `; expires=${date.toUTCString()}`;
  }
  
  document.cookie = `${name}=${encodeURIComponent(value)}${expires}; path=${path}`;
}

/**
 * Deletes a cookie by name
 * @param name - Cookie name to delete
 * @param path - Cookie path (default: '/')
 */
export function deleteCookie(name: string, path: string = '/'): void {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=${path}`;
}